import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-2xl text-center" data-id="element-241" data-mp="3f1vij76y7va8">
      <h2 className={`font-serif text-[28px] font-bold leading-tight sm:text-4xl ${dark ? 'text-white' : 'text-ink'}`} data-id="element-242" data-mp="3f3gft4kndsbs">{title}</h2>
      {subtitle && <p className={`mt-3 text-[17px] leading-relaxed ${dark ? 'text-lavender-deep' : 'text-muted'}`} data-id="element-243" data-mp="bk3qjsstbbc1">{subtitle}</p>}
    </div>;
}